import React from 'react';
import PropTypes from 'prop-types';
import { Drawer, Form } from 'antd';

import DocumentTemplateForm from 'works/legacy/pages/organization/admin-settings/templates-page/onboarding-list-templates/onboarding-lists-template-items/item-forms/document-template-form';
import FormAssessmentTemplate from 'works/legacy/pages/organization/admin-settings/templates-page/onboarding-list-templates/onboarding-lists-template-items/item-forms/form-assessment-template';
import FormCertificationTemplate from 'works/legacy/pages/organization/admin-settings/templates-page/onboarding-list-templates/onboarding-lists-template-items/item-forms/form-certification-template';
import FormHealthDocumentTemplate from 'works/legacy/pages/organization/admin-settings/templates-page/onboarding-list-templates/onboarding-lists-template-items/item-forms/form-health-document-template';
import FormLicenseTemplate from 'works/legacy/pages/organization/admin-settings/templates-page/onboarding-list-templates/onboarding-lists-template-items/item-forms/form-license-template';
import FormOtherDocumentTemplate from 'works/legacy/pages/organization/admin-settings/templates-page/onboarding-list-templates/onboarding-lists-template-items/item-forms/form-other-document-template';
import FormActions from 'works/legacy/pages/organization/admin-settings/templates-page/onboarding-list-templates/onboarding-lists-template-items/form-actions';

import {
  BACKGROUND_IDENTIFICATION_TYPE,
  IMMIGRATION_TYPE,
  LICENSE_TYPE,
  CERTIFICATION_TYPE,
  ASESSMENT_TYPE,
  HEALTH_DOC,
  OTHER_DOCUMENT,
} from './compliance-item-types';

const ItemTypeTitles = {
  [BACKGROUND_IDENTIFICATION_TYPE]: 'Background and Identification',
  [IMMIGRATION_TYPE]: 'Immigration',
  [LICENSE_TYPE]: 'License',
  [CERTIFICATION_TYPE]: 'Certification',
  [ASESSMENT_TYPE]: 'Assessment',
  [HEALTH_DOC]: 'Health Document',
  [OTHER_DOCUMENT]: 'Other Document',
};

function EditItemForm({ dismiss, item, handleSubmit, form }) {
  function renderForm(type) {
    switch (type) {
      case 'Works::Onboarding::WorksListItemTypes::BackgroundIdentification':
        return (
          <DocumentTemplateForm
            categories={['background', 'identity', 'facility_required']}
            initialValues={{
              documentTemplateId:
                item.documentTemplateId || item.documentTemplate?.id,
              ...item,
            }}
            dismiss={dismiss}
            handleSubmit={(values) => handleSubmit(values, type, item.id)}
            form={form}
          />
        );
      case 'Works::Onboarding::WorksListItemTypes::Immigration':
        return (
          <DocumentTemplateForm
            categories={['immigration']}
            initialValues={{
              documentTemplateId:
                item.documentTemplateId || item.documentTemplate?.id,
              ...item,
            }}
            dismiss={dismiss}
            handleSubmit={(values) => handleSubmit(values, type, item.id)}
            form={form}
          />
        );
      case 'Works::Onboarding::WorksListItemTypes::License':
        return (
          <FormLicenseTemplate
            initialValues={item}
            dismiss={dismiss}
            handleSubmit={(values) => handleSubmit(values, type, item.id)}
            form={form}
          />
        );
      case 'Works::Onboarding::WorksListItemTypes::Certification':
        return (
          <FormCertificationTemplate
            initialValues={{
              certificationId: item.certificationId || item.certification?.id,
              ...item,
            }}
            dismiss={dismiss}
            handleSubmit={(values) => handleSubmit(values, type, item.id)}
            form={form}
          />
        );
      case 'Works::Onboarding::WorksListItemTypes::Assessment':
        return (
          <FormAssessmentTemplate
            initialValues={{
              assessmentId: item.assessment?.id || item.assessmentId,
              issuersId:
                item.assessmentIssuers?.map((i) => i.id) || item.issuersId,
              ...item,
            }}
            dismiss={dismiss}
            handleSubmit={(values) => handleSubmit(values, type, item.id)}
            form={form}
            currentAssessment={item.assessment}
            currentIssuers={item.assessmentIssuers}
          />
        );
      case 'Works::Onboarding::WorksListItemTypes::HealthDocument':
        return (
          <FormHealthDocumentTemplate
            showSeason={false}
            initialValues={{
              healthDocId: item.healthDocId || item.healthDoc?.id,
              ...item,
            }}
            dismiss={dismiss}
            handleSubmit={(values) => handleSubmit(values, type, item.id)}
            form={form}
          />
        );
      case 'Works::Onboarding::WorksListItemTypes::OtherDocument':
        return (
          <FormOtherDocumentTemplate
            initialValues={item}
            dismiss={dismiss}
            handleSubmit={(values) => handleSubmit(values, type, item.id)}
            form={form}
          />
        );
    }
  }

  return (
    <React.Fragment>
      <React.Fragment>{renderForm(item.type)}</React.Fragment>
    </React.Fragment>
  );
}

EditItemForm.propTypes = {
  item: PropTypes.object.isRequired,
  dismiss: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
};

export function CandidateAssignmentItemEditModal({
  item,
  dismiss,
  handleSubmit,
}) {
  const [form] = Form.useForm();

  return (
    <Drawer
      title={`Edit ${ItemTypeTitles[item.type]} Item`}
      visible={true}
      width={550}
      onClose={dismiss}
      footer={<FormActions onCancel={dismiss} onSubmit={form.submit} />}
    >
      <EditItemForm
        form={form}
        item={item}
        dismiss={dismiss}
        handleSubmit={handleSubmit}
      />
    </Drawer>
  );
}

CandidateAssignmentItemEditModal.propTypes = {
  item: PropTypes.object.isRequired,
  dismiss: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};
